var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "financeCalculator__quote" }, [
    _c(
      "div",
      { staticClass: "financeCalculator__quoteGrid" },
      _vm._l(5, function (i) {
        return _c("div", {
          staticClass:
            "financeCalculator__quoteGrid__item financeCalculator__quoteGrid__item--loading",
        })
      }),
      0
    ),
    _vm._v(" "),
    _c("div", {
      staticClass:
        "financeCalculator__quoteTotal financeCalculator__quoteTotal--loading",
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }